<template>
  <v-card
    color="grey lighten-5"
    elevation="1"
    class="pa-1 max-shadow"
  >
    <v-icon style="font-size: 80px">
      {{ fileIcons[file.extension] || 'insert_drive_file' }}
    </v-icon>
    <div
      class="caption"
      style="word-break: break-word"
    >
      {{ file.name }}
    </div>
    <v-card-actions>
      <v-btn
        icon
        @click="downloadFile"
      >
        <v-icon color="grey darken-1">
          get_app
        </v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        icon
        @click="deleteFile"
      >
        <v-icon color="grey darken-1">
          delete
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FileSaver from 'file-saver';

export default {
  name: 'MTFile',
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fileIcons: {
        png: 'mdi-file-image',
        jpeg: 'mdi-file-image',
        jpg: 'mdi-file-image',
        xls: 'mdi-file-excel',
        txt: 'mdi-file-document-outline',
        pdf: 'mdi-file-pdf',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word'
      }
    };
  },
  methods: {
    downloadFile() {
      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = () => {
        let blob = xhr.response;
        FileSaver.saveAs(blob, this.file.name);
      };
      xhr.open('GET', this.file.downloadUrl);
      xhr.send();
    },
    deleteFile() {
      this.$emit('delete', this.file);
    }
  }
};
</script>
